import { Box } from '@mui/material';
import React from 'react';
import { connectRange } from 'react-instantsearch-dom';
import styled from '@emotion/styled';

import { BREAKPOINTS, SPACE } from '@/constants';
import { getSliderAriaLabelArray } from '@/utils/get-slider-aria-label-array';
import Slider from '@/components/slider';
import { H7 } from '@/components/type';

const SliderPanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: calc(${SPACE.X1} + ${SPACE.X0}) 0;
`;

const StyledSlider = styled(Slider)`
  &.MuiSlider-root {
    @media (min-width: ${BREAKPOINTS.MD}px) {
      width: 610px;
    }
    width: 90%;
  }
`;

const SliderPanel = ({
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'getAriaValueText' implicitly has an 'any' type.
  getAriaValueText,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'allMarks' implicitly has an 'any' type.
  allMarks,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'uiSelectedRange' implicitly has an 'any' type.
  uiSelectedRange,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'updateUiSelectedRange' implicitly has an 'any' type.
  updateUiSelectedRange,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'updateSelectedRange' implicitly has an 'any' type.
  updateSelectedRange,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'name' implicitly has an 'any' type.
  name,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'formatter' implicitly has an 'any' type.
  formatter,
}) => {
  return (
    <SliderPanelWrapper>
      <H7 id={`${name}-slider-panel`}>Set your {name} range:</H7>
      <Box my={SPACE.X0}>
        <h4>
          {formatter(uiSelectedRange[0])} to {formatter(uiSelectedRange[1])}
        </h4>
      </Box>

      <StyledSlider
        {...{
          getAriaLabel: (index) => getSliderAriaLabelArray(name)[index],
          disableSelectingSingleValue: false,
          getAriaValueText,
          marks: allMarks,
          uiSelectedRange,
          updateUiSelectedRange,
          updateSelectedRange,
          sliderType: name,
        }}
      />
    </SliderPanelWrapper>
  );
};

const ConnectedSliderPanel = connectRange(SliderPanel);
export const VirtualRange = connectRange(() => null);
export default ConnectedSliderPanel;
